import React from 'react'
import { BotonCard } from './buttonStyle'
import './button.scss'
const ButtonCard = ({ direccion, id_boton, clases, nombre, funcion ,tipo}) => {
  return (
    <BotonCard
      id={id_boton}
      href={direccion}
      onClick={funcion}
      className={clases}
      type={tipo}
    >
      {nombre}
    </BotonCard>
  )
}

export default ButtonCard
